import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import type { PortfolioAddItemId } from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";

const ROUTES_BY_ITEM_ID: Partial<Record<PortfolioAddItemId, () => string>> = {
	auto: Routing.Portfolio.PortfolioAddCar.path,
	art: Routing.Portfolio.PortfolioAddArt.path,
	propertyItem: Routing.Portfolio.PortfolioAddRealEstate.path,
	buildingSavings: Routing.Portfolio.PortfolioAddBuildingSavings.path,
	crypto: Routing.Portfolio.PortfolioAddCryptocurrency.path,
	mortgage: () => Routing.Portfolio.PortfolioAddLoans.path("mortgage"),
	consumerLoan: () => Routing.Portfolio.PortfolioAddLoans.path("consumerLoan"),
	leasing: Routing.Portfolio.PortfolioAddLeasing.path,
	businessLoan: Routing.Portfolio.PortfolioAddBusinessLoans.path,
	commodity: Routing.Portfolio.PortfolioAddCommodities.path,
	bankProduct: Routing.Portfolio.PortfolioAddBankProduct.path,
	pension: Routing.Portfolio.PortfolioAddPension.path,
	investment: Routing.Portfolio.PortfolioAddInvestment.path,
	lifeInsurance: Routing.Portfolio.PortfolioAddLifeInsurance.path,
	propertyInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("property"),
	householdInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("household"),
	liabilityInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("liability"),
	vehicleInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("vehicle"),
	travelInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("travel"),
	businessInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("business"),
	accidentInsurance: () =>
		Routing.Portfolio.PortfolioAddNonLifeInsurance.path("accident"),
	service: Routing.Portfolio.PortfolioAddServices.path,
};

export const useNavigatePortfolioAddItem = () => {
	const navigate = useNavigate();

	return useCallback(
		(id: PortfolioAddItemId) => {
			const getPath = ROUTES_BY_ITEM_ID[id];
			if (getPath) {
				navigate(getPath());
			}
		},
		[navigate],
	);
};
